import React from "react";
import CleaningChemicals from "components/app/report/environment/cleaningChemicals/CleaningChemicals";

type ScreenCleaningChemicalsProps = React.PropsWithChildren<{}>;

function ScreenCleaningChemicals(props: ScreenCleaningChemicalsProps) {
	return <CleaningChemicals />;
}

export default ScreenCleaningChemicals;
